import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import {Ecc, QrCode} from './qrcodegen-v1.8.0-es6';

const QrCodeSVGComponent = props => {
    const url = new URL(props.value);
    let size = props.size;
    if (props.autoFillHeightWidth) {
        const cells = QrCode.encodeText(url.href, Ecc.LOW).modules;
        size = cells.length * 2;
    }
    const {autoFillHeightWidth, ...rest} = props; // not passing autoFillHeightWidth

    return (
        <QRCode
            className="qrcode"
            renderAs="svg"
            data-url={url.href}
            value={url.href}
            {...rest}
            size={size}
        />
    );
};

QrCodeSVGComponent.propTypes = {
    autoFillHeightWidth: PropTypes.bool,
    value: PropTypes.string.isRequired,
    size: PropTypes.number,
};

export default QrCodeSVGComponent;
